export default function controlMainDirective() {
  return {
    template: require('./control-main.html'),
    restrict: 'E',
    controller: 'ControlMainController',
    controllerAs: 'controlMainVM',
    bindToController: true,
    replace: true,
    scope: {
      controlDetail: '=',
      isAssign: '=',
      tooltipAppendToSelector: '@',
      risk: '<'
    },
  };
}
